import { render, staticRenderFns } from "./writeOffMuseum.vue?vue&type=template&id=0ccef414&scoped=true"
import script from "./writeOffMuseum.vue?vue&type=script&lang=js"
export * from "./writeOffMuseum.vue?vue&type=script&lang=js"
import style0 from "./writeOffMuseum.vue?vue&type=style&index=0&id=0ccef414&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccef414",
  null
  
)

export default component.exports